import React from 'react';
import { Icon } from 'antd';
import styles from './ViewCount.module.scss';

const ViewCount = ({ count }) => {
  return (
    <div className={styles.root}>
      <Icon type="eye" theme="filled" className={styles.icon} />
      <p className={styles.count}>{count}</p>
    </div>
  );
};

export default ViewCount;
